var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"project",class:{ 'project-slideable': _vm.phone },style:(_vm.style),on:{"click":function($event){$event.stopPropagation();return _vm.onClickProject($event)}}},_vm._l((_vm.filesRotated),function(file){return _c('file',{key:file.url,ref:"file",refInFor:true,staticClass:"foo",attrs:{"data-url":file.url,"url":file.url,"landscape":_vm.landscape}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e1a3c808","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/Project.vue
// module id = 93
// module chunks = 0